import { NavigationSidebar } from "./navigation";
import { LanguageSwitcher } from "./language-switcher";
import { Infobox } from "./infobox";

jQuery(($) => {
	/**
	 * Add Main navigation click handlers.
	 */
	const Navigation = new NavigationSidebar({
		navigation: $(".main-navigation"),
	});

	$(".js-main-navigation-open").on("click", () => Navigation.open());
	$(".js-main-navigation-close").on("click", () => Navigation.close());
	$("body").on("click", ".main-navigation.open", (e) => {
		// Only close if the user clicks on the overlay and not the child elements.
		if (e.target !== e.currentTarget) return;
		Navigation.close();
	});

	/**
	 * Close Main navigation with the ESC key.
	 */
	$(document).keyup((e) => {
		if (e.key !== "Escape") return;
		Navigation.close();
	});

	$("#site-header-search-button").on("click", () => {
		Navigation.open();
		Navigation.search.focus();
	});

	/**
	 * Language switchers
	 */
	const languageSwitches = [];
	$(".language-switcher").each(function () {
		const switcher = new LanguageSwitcher($(this));
		languageSwitches.push(switcher);
	});

	$("body").on("click", () => {
		// Close the open languageSwitchers if the menu is open and there is a click outside of the menu
		languageSwitches.forEach((switcher) => {
			if (switcher.isOpen()) {
				switcher.forceClose();
			}
		});
	});

	/**
	 * Accordions
	 */
	$("[data-accordion]:not(.open) [data-accordion-content]").hide();
	$("[data-accordion-title]").on("click", function (e) {
		e.preventDefault();
		$(this).parent().toggleClass("open");
		$(this).siblings("[data-accordion-content]").slideToggle();
	});

	/**
	 * Scroll to top button.
	 */
	const scrollTopButton = $(".scroll-to-top");

	$(window).scroll(function () {
		const offset = 1000;
		const distanceFromTop = $(window).scrollTop();

		if (distanceFromTop > offset) {
			scrollTopButton.fadeIn("slow");
		} else if (scrollTopButton.is(":visible")) {
			scrollTopButton.fadeOut("slow");
		}
	});

	scrollTopButton.on("click", function (e) {
		e.preventDefault();
		$(window).scrollTop(0);
	});

	/**
	 * Creates a global function to updated url parameters on language switcher options
	 */
	window.updateLangSwitcherParams = (url = window.location.href) => {
		/**
		 * Loops trough the language switchers
		 */
		languageSwitches.forEach((switcher) => {
			switcher.loopOptions((option) => {
				option.updateParameters(url);
			});
		});
	};

	const shareButtons = $(".social-share-window");

	if (shareButtons.length) {
		shareButtons.click(function (e) {
			const { shareUrl, title } = this.dataset;
			if (shareUrl) e.preventDefault();

			const newwindow = window.open(
				shareUrl,
				title,
				"height=300,width=700"
			);
			if (window.focus) {
				newwindow.focus();
			}
		});
	}

	const infoboxes = $(".box");

	infoboxes.each(function (i, infobox) {
		if (infobox.classList.contains("box--expandable")) {
			if (!window.infoboxes) window.infoboxes = [];
			window.infoboxes.push(new Infobox(infobox));
		}
	});
});
